export const environment = {
  production: true,
  API_BASE_URL: '/api',
  VERSION: 'v7.20.1.1.1.4'
};
